import { render, staticRenderFns } from "./tplEmailSend.vue?vue&type=template&id=5cba2b94&scoped=true&"
import script from "./tplEmailSend.vue?vue&type=script&lang=js&"
export * from "./tplEmailSend.vue?vue&type=script&lang=js&"
import style0 from "./tplEmailSend.vue?vue&type=style&index=0&id=5cba2b94&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba2b94",
  null
  
)

export default component.exports